import axios from "axios";

export default function OffermDeleteService(offerId) {
  return axios({
    method: 'delete',
    url: process.env.REACT_APP_API_HOST + "/api/v2/offer/" + offerId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
